<template>
  <div id="hot-values" class="widget">
    <div class="draggable">
      <div class="hot-values-top">
        <h4 class="hot-values-title">Valores comentados</h4>
        <div class="hot-values-top-box">
          <a class="hot-values" :href="gd_url + value_selected">GD</a>
          <span class="material-icons blue" @click="_sendDataToIframe()"
            >help</span
          >
          <span @click="_closeWidget()" class="material-icons">close</span>
        </div>
      </div>
    </div>
    <div v-if="loading"></div>
    <div v-else>
      <SelectOutline
        :helper_select_permission="false"
        :label_name="label_name"
        :options="options"
        :component_class="component_class"
        :helper_text_select="helper_text_select"
        :default_value="default_value"
        @_emit_method_order_select="_selectValue"
      />

      <TableCustom
        :table_header="table_header"
        :table_body="table_body"
        id="table-hot-values"
        class="widgets-container"
      />
      <!--<button style="background-color:transparent; border:none; cursor:pointer;" id=btns @click="_hola()"><img src="@/views/widgets/assets/eye-open.png" height=16 weight=16></button>-->
    </div>
  </div>
</template>

<script>
import APICaller from "@/components/codeComponents/APICaller.js";
import SelectOutline from "@/components/helpers/SelectOutline.vue";
import TableCustom from "@/components/helpers/Table_custom.vue";
import { mapGetters } from "vuex";

export default {
  mixins: [APICaller],
  name: "HotValues",
  components: {
    SelectOutline,
    TableCustom,
  },
  data() {
    return {
      gd_url: "",
      label_name: "Selecciona",
      options: [
        { name: "last_week", value: "Última semana" },
        { name: "last_month", value: "Último mes" },
        { name: "last_three_months", value: "Últimos 3 meses" },
        { name: "last_year", value: "Último año" },
      ],
      component_class: "hot_values",
      helper_text_select: "",
      default_value: "last_year",

      value_selected: "last_year",

      user_id: "",
      user_info: "",
      user_is_pre_eureker: "",
      values_hot: [],
      imgs: [],
      html_widget: "",

      table_header: ["Ticker", "Comentarios"],
      table_body: [],
      widget_name: { id: "widget-hot-values", name: "Más comentados" },
      loading: true,

      url_iframe:
        "https://player.vimeo.com/video/187305384?title=0&byline=0&portrait=0&autoplay=1",
      help_tittle: "Ayuda sobre valores más comentados",
    };
  },
  created() {},
  mounted() {
    this.gd_url =
      this.$detectEnvironment() + "/app/graficador-dinamico/hot-values/";

    var bullish = setInterval(() => {
      if (this.value_selected != "") {
        this._getHotValues();
        this.loading = false;
        clearInterval(bullish);
      }
    }, 100);
  },
  computed: {
    ...mapGetters(["is_mobile_device"]),
  },
  methods: {
    _sendDataToIframe: function() {
      this.$emit("url_iframe", this.url_iframe);
      this.$emit("help_tittle", this.help_tittle);
      this.$emit("load_iframe");
    },

    _getHotValues() {
      let success = (response) => {
        let hotValues = response.data;

        Object.entries(hotValues).forEach((e) => {
          let obj = {};
          if (e[1].nom == "---") {
            obj["ticker"] = e[1].nom;
          } else {
            obj["ticker"] = e[1].ticker;
          }
          obj["comentario"] = e[1].total_comments;
          this.table_body.push(obj);
        });
      };

      let url = "/api/v1/stock-finder/hot-values/" + this.value_selected;

      if (this.value_selected && this.value_selected != "") {
        const successHandler = new APICaller.SuccessHandler(success);
        const failureHandler = new APICaller.FailureHandler(
          "167",
          "Error recuperando valores más comentados."
        );
        const apiCallConfig = { loadingOverlay: false };

        this._getAPICall(url, successHandler, failureHandler, apiCallConfig);
      }
    },
    _selectValue(value) {
      if (value != undefined) {
        this.value_selected = value[0];
        this.table_body = [];
        this._getHotValues();
      }
    },

    _closeWidget: function() {
      this.$emit("widget_name", this.widget_name);
    },
  },
};
</script>

<style lang="scss" scoped>
.widget {
  border-radius: 5px;
  height: 350px;
  width: 420px;
  padding: 5px;
  background-color: white;
  position: relative;
}

@media (max-width: 450px) {
  .widget {
    border-radius: 5px;
    padding: 5px;
    background-color: white;
    width: calc(100% - 10px);
  }
}

.widget:hover {
  border-top: 2px solid #00add8;
}

.hot-values-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.hot-values-top-box {
  display: flex;
  align-items: center;
}

.material-icons {
  margin-left: 5px;
}
.material-icons:hover {
  cursor: pointer;
}

h4 {
  color: #00add8;
}

a {
  text-decoration: none;
  color: #00add8;
  font-weight: bold;
}

.blue {
  color: #00add8;
}

.blue:hover {
  border-bottom: 1px solid #00add8;
}

.hot-values-text {
  font-size: 14px;
  line-height: 22px;
}
.draggable {
  cursor: move;
}
</style>
